<template>
    <v-container class="py-8 text-center" style="max-width: 560px">
        <v-icon size="64" color="medium-emphasis">mdi-map-marker-question-outline</v-icon>
        <h1 class="text-h5 mt-4">No app at this address</h1>
        <p class="text-body-2 text-medium-emphasis mt-2">
            <code>{{ $route.fullPath }}</code> does not match a registered app.
        </p>
        <v-btn color="primary" variant="flat" to="/" class="mt-6">
            <v-icon start>mdi-home</v-icon>
            Back to the app index
        </v-btn>
    </v-container>
</template>
